exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tools[data-v-fc212702] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.tools .mr10[data-v-fc212702] {\n  border-radius: 5px;\n}\n.tools .page[data-v-fc212702] {\n  font-size: 18px;\n  color: aqua;\n  margin: 0 20px;\n}\n", ""]);

// exports
